import type { GraphItemsModel } from './types';
import type { GraphItem } from '../graphItems/GraphItem';

type ViewModelGraph<TNode extends GraphItem, TGroup extends GraphItem> = {
  nodes: GraphItemsModel<TNode>;
  groups: GraphItemsModel<TGroup>;
};

const getGraphNodeCount = <TNode extends GraphItem, TGroup extends GraphItem>({
  nodes,
  groups,
}: ViewModelGraph<TNode, TGroup>) => {
  const leafNodesCount = nodes.add.length + nodes.update.length;
  const groupNodesCount = groups.add.length + groups.update.length;
  return leafNodesCount + groupNodesCount;
};
export { getGraphNodeCount };
